import React, { useEffect, useState } from 'react';
import api from '../services/api';

const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [error, setError] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const response = await api.get(`/profile`);
        setProfile(response.data);
      } catch (err) {
        setError('Erro ao buscar perfil.');
      }
    };

    fetchProfile();
  }, []);

  return (
    <div style={{ padding: '2rem', backgroundColor: 'var(--color-light)', color: 'var(--color-dark)' }}>
      <h1 style={{ color: 'var(--color-primary)' }}>Perfil do Usuário</h1>
      {error && <p style={{ color: 'red' }}>{error}</p>}
      {profile ? (
        <div>
          <p>ID: {profile.user_id}</p>
          <p>Mensagem: {profile.message}</p>
        </div>
      ) : (
        <p>Carregando...</p>
      )}
    </div>
  );
};

export default Profile;
